import React, { useEffect, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Image, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import MDatePicker from '../../components/MDatePicker';
import Calendar from '../../assets/img/calendar.svg';
import Search from '../../assets/img/search.svg';
import Cancel from '../../assets/img/circleCancel.svg';
import successTick from '../../assets/img/successTick.svg';
import DisablesuccessTick from '../../assets/img/disableSuccess.svg';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TASK_ACTION,
} from '../../utils/Constant';
import SearchIcon from '@mui/icons-material/Search';
import {
  ColXsMdType,
  CreateLeadLocationDataType,
  EmployeeNameType,
  LeadDetailsType,
  LeadItemType,
  MapOptionType,
  MUILocationFilterType,
  PincodeDataType,
  SelectOptionType,
} from '../../utils/Types';
import { fetchEmployeeNames, taskSelector } from '../../features/taskSlice';
import { SelectChangeEvent } from '@mui/material/Select';
import moment from 'moment';
import MAutoComplete from '../../components/MAutoComplete';
import CenterSpinner from '../../components/CenterSpinner';
import { getNoteDate } from '../../utils/Util';
import { useNavigate } from 'react-router-dom';
import {
  fetchLeadStatusDrops,
  fetchLeadTypeBankDrops,
  fetchLeadTypeBranchDrops,
  fetchLeadTypeDropdownDrops,
  fetchLeadTypeDrops,
  fetchLeadTypeProductDrops,
  leadSelector,
} from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  assignTask,
  createLead,
  findSelectedLeadDetails,
  saveComment,
  updateLeadStatus,
  VIEW_LEADDETAILS_HEADER,
} from './LeadPageHelper';
import {
  getDefaultLocation,
  getEmployee,
  getEmployeeNameList,
  getLocation,
  updateSelectedEmployee,
} from '../task-assigned/TaskAssignHelper';
import KTable from '../../components/KTable';
import { toast } from 'react-toastify';
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import CropSectionPage from './CropSectionPage';
import OtherSectionPage from './OtherSectionPage';
import MotorSectionPage from './MotorSectionPage';
import HealthSectionPage from './HealthSectionPage';

const blankSelectedEmployee: EmployeeNameType = {
  employeeName: '',
  roleName: '',
  roleId: '',
  mobileNumber: '',
  employeeUniqueId: '',
  candidateId: '',
};
const blankLocation = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
interface ICreateTaskPageProps {
  title?: string;
  leadToView?: LeadItemType;
  leadStatusName?: string;
  onTaskAction?: (action: string) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const CreateLeadPage: React.FunctionComponent<ICreateTaskPageProps> = ({
  title,
  onTaskAction,
  leadToView,
  leadStatusName,
}: ICreateTaskPageProps) => {
  const [leadStatus, setLeadStatus] = useState(TASK_ACTION.CREATE);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [leadUniqueId, setLeadUniqueId] = useState('');
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [selectedLeadData, setSelectedLeadData] = useState<any>({});
  const [selectedBank, setSelectedBank] = useState<number>();
  const [selectedBranch, setSelectedBranch] = useState<number>();
  const [rmName, setRMName] = useState<any>('');
  const [rmMobileNum, setRMMobileNumber] = useState<any>('');
  const leadTypeOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeOptions;
  const leadTypeProductOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeProductOptions;
  const leadTypeBankOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeBankOptions;
  const leadTypeBranchOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeBranchOptions;
  const leadTypeLobName: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeLobName;
  const [selectedLeadTypeId, setSelectedLeadTypeId] = useState<number>();
  const [leadTypeDropOptions, setLeadTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadProductTypeDropOptions, setLeadProductTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadBankTypeDropOptions, setLeadBankTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadBranchTypeDropOptions, setLeadBranchTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadTypeLOBOptions, setLeadTypeLOBOptions] = useState<
    SelectOptionType[]
  >([]);
  const [optionEmployeeName, setOptionEmployeeName] = useState<
    SelectOptionType[]
  >([]);
  const [ifPincode, setIfPincode] = useState<boolean>(false);
  const [pincodeData, setPincodeData] = useState<PincodeDataType[]>([]);
  const [selectedPincodeData, setSelectedPincodeData] = React.useState<any>({
    label: '',
    value: '',
  });
  const [inputValue, setInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState<boolean>(false);
  const [leadMotorDetails, setLeadMotorDetails] = useState<any>({});
  const [leadMotorList, setLeadMotorList] = useState<any[]>([]);
  const [leadOtherDetails, setLeadOtherDetails] = useState<any>({});
  const [leadOtherList, setLeadOtherList] = useState<any[]>([]);
  const [leadHealthDetails, setLeadHealthDetails] = useState<any>({});
  const [leadHealthList, setLeadHealthList] = useState<any[]>([]);
  const [leadCropDetails, setLeadCropDetails] = useState<any>({});
  const [leadCropList, setLeadCropList] = useState<any[]>([]);
  const [lobName, setLobName] = useState<any>();

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;

  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;
  const [leadDetails, setLeadDetails] = useState<any>({});
  const [leadList, setLeadList] = useState<any[]>([]);
  const [zoneName, setZoneName] = useState<any>('');
  const [stateName, setStateName] = useState<any>('');
  const [districtName, setDistrictName] = useState<any>('');
  const [villageName, setVillageName] = useState<any>('');
  const [locationData, setLocationData] =
    useState<CreateLeadLocationDataType>(blankLocation);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeNameType>(
    blankSelectedEmployee
  );
  const [completionDateTime, setCompletionDateTime] = useState(
    leadToView
      ? moment(leadToView.createdOn).format('DD-MM-YYYY H:mm')
      : moment(new Date()).format('DD-MM-YYYY H:mm')
  );
  const [comment, setComment] = useState<string>();
  const statusDropOptions: SelectOptionType[] =
    useAppSelector(leadSelector).statusDropOptions;
  const [optionTaskStatus, setOptionTaskStatus] = useState<number>();
  const [leadToViewDetails, setLeadToViewDetails] = useState<LeadDetailsType>();
  const [defaultLocationOptions, setDefaultLocationOptions] = useState<any>({});
  const employeeList: EmployeeNameType[] =
    useAppSelector(taskSelector).employeeList;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const navigateToViewListPage = () => {
    clearFields();
  };

  const clearFields = () => {
    setSelectedLeadTypeId(undefined);
    setSelectedEmployee(blankSelectedEmployee);
    setLeadDetails({
      name: '',
      contactNumber: '',
    });
    setSelectedLeadData({
      productId: '',
      cropName: '',
      loanAmount: '',
    });
    setLeadCropDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      loaneeStatus: '',
      bankName: '',
      branchName: '',
      tenantStatus: '',
      surveyNumber: '',
      subSurveyNumber: '',
      timeframeOfPurchase: '',
      pastInsurance: '',
      insuredArea: '',
      areaDec: '',
      bankNameData: '',
      branchNamedata: '',
    });
    setLeadMotorDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      riskCoverage: '',
      vehicleType: '',
      make: '',
      OwnerNameASPerRC: '',
      VehicleRegnNo: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      riskCoverageName: '',
      vehicleTypeName: '',
    });
    setLeadHealthDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      typeofCover: '',
      coverage: '',
      coverageFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      typeofCoverName: '',
      coverageName: '',
      coverageForName: '',
    });
    setLeadOtherDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      interestedFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      intrestedForName: '',
    });
    setRMName('');
    setRMMobileNumber('');
    setSelectedBank(undefined);
    setSelectedBranch(undefined);
    setLocationData(blankLocation);
    setComment('');
    setCompletionDateTime(moment().format('DD-MM-YYYY H:mm'));
    setLeadList([]);
    setLeadCropList([]);
    setLeadOtherList([]);
    setLeadMotorList([]);
    setLeadHealthList([]);
    setIfPincode(false);
    setPincodeData([]);
    setInputValue('');
    setLobName(undefined);
    localStorage.removeItem('createLeadList');
  };

  const handleLeadsData = (leadDetails?: LeadDetailsType) => {
    if (leadDetails) {
      setSelectedLeadTypeId(leadDetails.leadTypeId);
      setSelectedEmployee(getEmployee(leadDetails));
      setLobName(leadDetails?.lobId);
      setLeadDetails({
        name: leadDetails?.leadName,
        contactNumber: leadDetails?.leadNumber,
      });
      setSelectedLeadData({
        productId: leadDetails?.rmProduct,
        cropName: leadDetails?.cropName,
        loanAmount: leadDetails?.loanAmt,
      });
      setLeadCropDetails({
        firstname: leadDetails?.firstName ?? '',
        lastname: leadDetails?.lastName ?? '',
        contactNumber: leadDetails?.leadNumber ?? '',
        alternateContactNumber: leadDetails?.alternateMobileNumber ?? '',
        loaneeStatus: leadDetails?.loaneeStatus ?? '',
        bankName: leadDetails?.rmBankId ?? '',
        branchName: leadDetails?.rmBranchId ?? '',
        tenantStatus: leadDetails?.tenantStatus ?? '',
        surveyNumber: leadDetails?.surveyNumber ?? '',
        subSurveyNumber: leadDetails?.subSurveyNumber ?? '',
        timeframeOfPurchase:
          moment(leadDetails?.timeframeOfPurchase, 'YYYY-MM-DD').toDate() ?? '',
        pastInsurance: leadDetails?.pastInsurance ?? '',
        insuredArea: leadDetails?.insuredArea ?? '',
        areaDec: leadDetails?.areaDec ?? '',
        bankNameData: '',
        branchNamedata: '',
      });
      setLeadHealthDetails({
        firstname: leadDetails?.healthLobLeadReq?.firstName ?? '',
        lastname: leadDetails?.healthLobLeadReq?.lastName ?? '',
        contactNumber: leadDetails?.leadNumber ?? '',
        alternateContactNumber:
          leadDetails?.healthLobLeadReq?.alternateMobileNumber ?? '',
        typeofCover: leadDetails?.healthLobLeadReq?.typeOfCoverId ?? '',
        coverage: leadDetails?.healthLobLeadReq?.coverageId ?? '',
        coverageFor: leadDetails?.healthLobLeadReq?.coverageForId ?? '',
        AadharNumber: leadDetails?.healthLobLeadReq?.aadhaarNumber ?? '',
        date:
          moment(
            leadDetails?.healthLobLeadReq?.dateOfBirth,
            'YYYY-MM-DD'
          ).toDate() ?? '',
        timeframeOfPurchase:
          moment(
            leadDetails?.healthLobLeadReq?.timeframeOfPurchase,
            'YYYY-MM-DD'
          ).toDate() ?? '',
        everInsured: leadDetails?.healthLobLeadReq?.pastInsurance ?? '',
        additionalInformation:
          leadDetails?.healthLobLeadReq?.additionalInformation ?? '',
        typeofCoverName: '',
        coverageName: '',
        coverageForName: '',
      });
      setLeadMotorDetails({
        firstname: leadDetails?.motorLobLeadReq?.firstName ?? '',
        lastname: leadDetails?.motorLobLeadReq?.lastName ?? '',
        contactNumber: leadDetails?.leadNumber ?? '',
        alternateContactNumber:
          leadDetails?.motorLobLeadReq?.alternateMobileNumber ?? '',
        riskCoverage: leadDetails?.motorLobLeadReq?.riskCoverageId ?? '',
        vehicleType: leadDetails?.motorLobLeadReq?.vehicleTypeId ?? '',
        make: leadDetails?.motorLobLeadReq?.vehicleMake ?? '',
        OwnerNameASPerRC: leadDetails?.motorLobLeadReq?.ownerNameAsPerRc ?? '',
        VehicleRegnNo:
          leadDetails?.motorLobLeadReq?.vehicleRegistrationNumber ?? '',
        AadharNumber: leadDetails?.motorLobLeadReq?.aadhaarNumber ?? '',
        date:
          moment(
            leadDetails?.motorLobLeadReq?.dateOfBirth,
            'YYYY-MM-DD'
          ).toDate() ?? '',
        timeframeOfPurchase:
          moment(
            leadDetails?.motorLobLeadReq?.timeframeOfPurchase,
            'YYYY-MM-DD'
          ).toDate() ?? '',
        everInsured: leadDetails?.motorLobLeadReq?.pastInsurance ?? '',
        additionalInformation:
          leadDetails?.motorLobLeadReq?.additionalInformation ?? '',
        riskCoverageName: '',
        vehicleTypeName: '',
      });
      setLeadOtherDetails({
        firstname: leadDetails?.otherLobLeadReq?.firstName ?? '',
        lastname: leadDetails?.otherLobLeadReq?.lastName ?? '',
        contactNumber: leadDetails?.leadNumber ?? '',
        alternateContactNumber:
          leadDetails?.otherLobLeadReq?.alternateMobileNumber ?? '',
        interestedFor: leadDetails?.otherLobLeadReq?.interestedForId ?? '',
        AadharNumber: leadDetails?.otherLobLeadReq?.aadhaarNumber ?? '',
        date: leadDetails?.otherLobLeadReq?.dateOfBirth
          ? moment(
              leadDetails.otherLobLeadReq.dateOfBirth,
              'YYYY-MM-DD'
            ).toDate()
          : '',
        timeframeOfPurchase:
          moment(
            leadDetails?.otherLobLeadReq?.timeframeOfPurchase,
            'YYYY-MM-DD'
          ).toDate() ?? '',
        everInsured: leadDetails?.otherLobLeadReq?.everInsured ?? '',
        additionalInformation:
          leadDetails?.otherLobLeadReq?.additionalInformation ?? '',
        intrestedForName: '',
      });
      setLocationData(getLocation(leadDetails));
      setDefaultLocationOptions(getDefaultLocation(leadDetails));
      setOptionTaskStatus(leadDetails.leadStatus);
      setLeadUniqueId(leadDetails.leadId);
      setCompletionDateTime(
        moment.utc(leadDetails.leadReceivedOn).local().format('DD-MM-YYYY H:mm')
      );
      setRMName(leadDetails?.rmName ?? '');
      setRMMobileNumber(leadDetails?.rmMobileNumber ?? '');
      setSelectedBank(leadDetails?.rmBankId ?? '');
      setSelectedBranch(leadDetails?.rmBranchId ?? '');
      dispatch(fetchLeadTypeBranchDrops({ bankId: leadDetails?.rmBankId }));
    } else {
      setLeadUniqueId(`LID-O-${moment(new Date()).format('DDMMYY')}-`);
    }
  };

  const onTaskNameChange = (selectedName: SelectChangeEvent) => {
    const value = Number(selectedName.target.value);
    setSelectedLeadTypeId(value);
    console.log('value-257', value);

    setSelectedEmployee(blankSelectedEmployee);
    setLeadDetails({
      name: '',
      contactNumber: '',
    });
    setSelectedLeadData({
      productId: '',
      cropName: '',
      loanAmount: '',
    });
    setLeadCropDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      loaneeStatus: '',
      bankName: '',
      branchName: '',
      tenantStatus: '',
      surveyNumber: '',
      subSurveyNumber: '',
      timeframeOfPurchase: '',
      pastInsurance: '',
      insuredArea: '',
      areaDec: '',
      bankNameData: '',
      branchNamedata: '',
    });
    setLeadMotorDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      riskCoverage: '',
      vehicleType: '',
      make: '',
      OwnerNameASPerRC: '',
      VehicleRegnNo: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      riskCoverageName: '',
      vehicleTypeName: '',
    });
    setLeadHealthDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      typeofCover: '',
      coverage: '',
      coverageFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      typeofCoverName: '',
      coverageName: '',
      coverageForName: '',
    });
    setLeadOtherDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      interestedFor: '',
      AadharNumber: '',
      date: '',
      timeframeOfPurchase: '',
      everInsured: '',
      additionalInformation: '',
      intrestedForName: '',
    });
    setLocationData(blankLocation);
    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);
    setSelectedPincodeData({
      label: '',
      value: '',
    });
    setLeadList([]);
    setLeadCropList([]);
    setLeadOtherList([]);
    setLeadMotorList([]);
    setLeadHealthList([]);
    setRMName('');
    setRMMobileNumber('');
    setSelectedBank(undefined);
    setSelectedBranch(undefined);
  };

  const fetchEmployeeNamesList = () => {
    dispatch(fetchLeadTypeProductDrops());
    dispatch(fetchLeadTypeBankDrops());
    dispatch(fetchLeadStatusDrops({ module: 4 }));
    dispatch(fetchEmployeeNames());
    dispatch(fetchLeadTypeDropdownDrops());
  };
  useEffect(() => {
    setOptionEmployeeName(getEmployeeNameList(employeeList));
  }, [employeeList]);
  useEffect(() => {
    setLeadStatus(leadStatusName ?? TASK_ACTION.CREATE);
    if (leadStatusName && leadStatusName === TASK_ACTION.VIEW) {
      setDisabled(true);
    }
    fetchEmployeeNamesList();
  }, [leadStatusName]);

  useEffect(() => {
    if (!leadStatusName && statusDropOptions?.length) {
      const initStatusValue = statusDropOptions?.filter(
        (item) => item.label === 'New'
      );
      setOptionTaskStatus(Number(initStatusValue[0].value));
    }
  }, [statusDropOptions, leadStatusName]);

  useEffect(() => {
    if (leadToView?.leadId) {
      findSelectedLeadDetails(
        setShowLoader,
        dispatch,
        handleLeadsData,
        setLeadToViewDetails,
        leadToView.leadId
      );
    }
  }, [leadToView]);
  /**
   * Filtering Lead type options for the create lead
   */
  useEffect(() => {
    if (leadToView?.leadId) {
      setLeadTypeDropOptions(leadTypeOptions);
    } else {
      const filterFieldTypeVal =
        leadTypeOptions?.filter(
          ({ value }) =>
            value == 3 ||
            value == 4 ||
            value == 5 ||
            value == 6 ||
            value == 7 ||
            value == 8
        ) || [];
      setLeadTypeDropOptions(filterFieldTypeVal);
    }
  }, [leadToView, leadTypeOptions]);

  useEffect(() => {
    setLeadProductTypeDropOptions(leadTypeProductOptions);
  }, [leadTypeProductOptions]);

  useEffect(() => {
    setLeadBankTypeDropOptions(leadTypeBankOptions);
  }, [leadTypeBankOptions]);

  useEffect(() => {
    setLeadBranchTypeDropOptions(leadTypeBranchOptions);
  }, [leadTypeBranchOptions]);

  useEffect(() => {
    setLeadTypeLOBOptions(leadTypeLobName);
  }, [leadTypeLobName]);

  useEffect(() => {
    console.log('leadStatus', leadStatus);
    if (leadStatus === TASK_ACTION.CREATE) {
      const savedLeadList = localStorage.getItem('createLeadList');

      console.log('savedLeadList', savedLeadList);

      if (savedLeadList) {
        setLeadList(JSON.parse(savedLeadList));
      }
      setIsLoaded(true);
    }
  }, [leadStatus]);

  useEffect(() => {
    if (isLoaded && leadStatus === TASK_ACTION.CREATE) {
      try {
        localStorage.setItem('createLeadList', JSON.stringify(leadList));
      } catch (error) {
        console.error('LocalStorage limit exceeded', error);
        toast.error('Unable to save draft data.');
      }
    }
  }, [leadList, leadStatus, isLoaded]);

  const validateLead = async (): Promise<boolean> => {
    const allZerosRegex = /^0+$/;
    const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
    const isValidName = (name: any) => {
      return (
        TEXT_ONLY_REGEX.test(name) &&
        name.trim().length >= 2 &&
        name.trim().length <= 50
      );
    };
    const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

    const LOAN_AMOUNT_REGEX = /^\d{1,8}(\.\d{1,2})?$/;

    const isValidLoanAmount = (amount: string | number) => {
      const value = String(amount).trim();
      return LOAN_AMOUNT_REGEX.test(value) && parseFloat(value) > 0;
    };

    if (!leadDetails?.name || !isValidName(leadDetails?.name)) {
      toast.error('Enter valid lead Name');
      return false;
    } else if (!numberRegex.test(leadDetails?.contactNumber)) {
      toast.error('Enter valid contact Number');
      return false;
    } else if (allZerosRegex.test(leadDetails?.contactNumber)) {
      toast.error('Contact number cannot consist of all zeros.');
      return false;
    } else if (leadDetails?.contactNumber.length !== 10) {
      toast.info('Contact Number must be 10 digits.');
      return false;
    } else if (!/^\d+$/.test(leadDetails?.contactNumber)) {
      toast.error('Contact Number should only contain digits');
      return false;
    } else if (!selectedLeadData?.productId) {
      toast.error('Product can not be empty');
      return false;
    } else if (
      selectedLeadData?.cropName &&
      !isValidName(selectedLeadData.cropName)
    ) {
      toast.error(
        'Enter valid Crop Name and it should not exceed 50 characters'
      );
      return false;
    } else if (
      selectedLeadData?.loanAmount &&
      !isValidLoanAmount(selectedLeadData.loanAmount)
    ) {
      toast.error('Loan Amount should be greater than 0, and up to 8 digits');
      return false;
    } else if (!locationData?.pincode) {
      toast.error('Pincode can not be empty.');
      return false;
    } else if (!locationData?.zone) {
      toast.info('Zone name can not be empty');
      return false;
    } else if (!locationData?.state) {
      toast.info('State name can not be empty');
      return false;
    } else if (!locationData?.district) {
      toast.info('District name can not be empty');
      return false;
    } else if (!locationData?.city) {
      toast.info('Village name can not be empty');
      return false;
    }

    return true;
  };
  const validateCropLead = async (): Promise<boolean> => {
    const allZerosRegex = /^0+$/;
    const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;

    const isValidName = (name: any) => {
      return (
        TEXT_ONLY_REGEX.test(name) &&
        name.trim().length >= 2 &&
        name.trim().length <= 100
      );
    };

    const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

    if (
      !leadCropDetails?.firstname ||
      !isValidName(leadCropDetails?.firstname)
    ) {
      toast.error('Enter valid First Name');
      return false;
    } else if (
      leadCropDetails?.lastname &&
      !isValidName(leadCropDetails?.lastname)
    ) {
      toast.error('Enter valid Last Name');
      return false;
    } else if (!numberRegex.test(leadCropDetails?.contactNumber)) {
      toast.error('Enter valid Mobile Number');
      return false;
    } else if (allZerosRegex.test(leadCropDetails?.contactNumber)) {
      toast.error('Mobile Number cannot consist of all zeros.');
      return false;
    } else if (leadCropDetails?.contactNumber.length !== 10) {
      toast.info('Mobile Number must be 10 digits.');
      return false;
    } else if (!/^\d+$/.test(leadCropDetails?.contactNumber)) {
      toast.error('Mobile Number should only contain digits');
      return false;
    } else if (
      leadCropDetails?.alternateContactNumber &&
      !numberRegex.test(leadCropDetails?.alternateContactNumber)
    ) {
      toast.error('Enter valid Alternate Mobile Number');
      return false;
    } else if (
      leadCropDetails?.alternateContactNumber &&
      allZerosRegex.test(leadCropDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Mobile Number cannot consist of all zeros.');
      return false;
    } else if (
      leadCropDetails?.alternateContactNumber &&
      leadCropDetails?.alternateContactNumber.length !== 10
    ) {
      toast.info('Alternate Mobile Number must be 10 digits.');
      return false;
    } else if (
      leadCropDetails?.alternateContactNumber &&
      !/^\d+$/.test(leadCropDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Mobile Number should only contain digits');
      return false;
    } else if (!locationData?.pincode) {
      toast.error('Pincode can not be empty.');
      return false;
    } else if (!locationData?.zone) {
      toast.info('Zone name can not be empty');
      return false;
    } else if (!locationData?.state) {
      toast.info('State name can not be empty');
      return false;
    } else if (!locationData?.district) {
      toast.info('District name can not be empty');
      return false;
    } else if (!locationData?.city) {
      toast.info('Village name can not be empty');
      return false;
    } else if (!leadCropDetails?.loaneeStatus) {
      toast.error('Loanee Status can not be empty');
      return false;
    } else if (
      leadCropDetails?.loaneeStatus === 'Loanee' &&
      !leadCropDetails?.bankName
    ) {
      toast.error('Bank Name can not be empty');
      return false;
    } else if (
      leadCropDetails?.loaneeStatus === 'Loanee' &&
      !leadCropDetails?.branchName
    ) {
      toast.error('Branch Name can not be empty');
      return false;
    } else if (!leadCropDetails?.tenantStatus) {
      toast.error('Tenant Status can not be empty');
      return false;
    } else if (!leadCropDetails?.surveyNumber) {
      toast.error('Survey Number can not be empty');
      return false;
    } else if (
      leadCropDetails?.surveyNumber &&
      leadCropDetails?.surveyNumber.trim().length > 25
    ) {
      toast.error('Survey Number cannot exceed 25 characters');
      return false;
    } else if (
      leadCropDetails?.subSurveyNumber &&
      leadCropDetails?.subSurveyNumber.trim().length > 25
    ) {
      toast.error('Sub Survey Number cannot exceed 25 characters');
      return false;
    } else if (!leadCropDetails?.timeframeOfPurchase) {
      toast.error('Timeframe Of Purchase cannot be empty');
      return false;
    } else if (
      leadCropDetails?.pastInsurance &&
      !['yes', 'no'].includes(leadCropDetails?.pastInsurance)
    ) {
      toast.error('Please select a valid Past Insurance option');
      return false;
    } else if (
      leadCropDetails?.insuredArea &&
      leadCropDetails?.insuredArea.length > 10
    ) {
      toast.error('Insured Area cannot exceed 10 characters');
      return false;
    } else if (
      leadCropDetails?.insuredArea &&
      !/^\d+(\.\d+)?$/.test(leadCropDetails.insuredArea)
    ) {
      toast.error('Insured Area should contain only numbers and decimals');
      return false;
    } else if (
      leadCropDetails?.areaDec &&
      !/^[a-zA-Z\s]+$/.test(leadCropDetails.areaDec)
    ) {
      toast.error('Area Description should contain only alphabets');
      return false;
    } else if (
      leadCropDetails?.areaDec &&
      leadCropDetails.areaDec.length > 10
    ) {
      toast.error('Area Description  cannot exceed 10 characters');
      return false;
    }

    return true;
  };

  const validateMotorLead = async (): Promise<boolean> => {
    const allZerosRegex = /^0+$/;
    const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
    const isValidName = (name: any) => {
      return (
        TEXT_ONLY_REGEX.test(name) &&
        name.trim().length >= 2 &&
        name.trim().length <= 100
      );
    };
    const numberRegex = /^[+]?(91)?[6789]\d{9}$/;
    const VEHICLE_NUMBER_REGEX = /^[A-Za-z0-9\s]+$/;

    const isValidVehicleNumber = (vehicleNo: string) => {
      return VEHICLE_NUMBER_REGEX.test(vehicleNo.trim());
    };

    const MAKE_REGEX = /^[a-zA-Z0-9\s@,./()&-]+$/;

    const isValidMake = (value: string) => {
      return value.trim().length >= 2 && value.trim().length <= 100;
    };

    if (
      !leadMotorDetails?.firstname ||
      !isValidName(leadMotorDetails?.firstname)
    ) {
      toast.error('Enter valid lead First Name');
      return false;
    } else if (
      !leadMotorDetails?.lastname ||
      !isValidName(leadMotorDetails?.lastname)
    ) {
      toast.error('Enter valid lead Last Name');
      return false;
    } else if (!numberRegex.test(leadMotorDetails?.contactNumber)) {
      toast.error('Enter valid contact Number');
      return false;
    } else if (allZerosRegex.test(leadMotorDetails?.contactNumber)) {
      toast.error('Contact number cannot consist of all zeros.');
      return false;
    } else if (leadMotorDetails?.contactNumber.length !== 10) {
      toast.info('Contact Number must be 10 digits.');
      return false;
    } else if (!/^\d+$/.test(leadMotorDetails?.contactNumber)) {
      toast.error('Contact Number should only contain digits');
      return false;
    } else if (
      leadMotorDetails?.alternateContactNumber &&
      !numberRegex.test(leadMotorDetails?.alternateContactNumber)
    ) {
      toast.error('Enter valid Alternate contact Number');
      return false;
    } else if (
      leadMotorDetails?.alternateContactNumber &&
      allZerosRegex.test(leadMotorDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact number cannot consist of all zeros.');
      return false;
    } else if (
      leadMotorDetails?.alternateContactNumber &&
      leadMotorDetails?.alternateContactNumber.length !== 10
    ) {
      toast.info('Alternate Contact Number must be 10 digits.');
      return false;
    } else if (
      leadMotorDetails?.alternateContactNumber &&
      !/^\d+$/.test(leadMotorDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact Number should only contain digits');
      return false;
    } else if (!leadMotorDetails?.riskCoverage) {
      toast.error('Risk Coverage can not be empty');
      return false;
    } else if (!leadMotorDetails?.vehicleType) {
      toast.error('Vehicle Type can not be empty');
      return false;
    } else if (!leadMotorDetails?.make) {
      toast.error('Make can not be empty');
      return false;
    } else if (!isValidMake(leadMotorDetails?.make)) {
      toast.error('Make cannot exceed 100 characters');
      return false;
    } else if (
      leadMotorDetails?.OwnerNameASPerRC &&
      !isValidName(leadMotorDetails?.OwnerNameASPerRC)
    ) {
      toast.error('Owner Name as per RC can not be empty');
      return false;
    } else if (!leadMotorDetails?.VehicleRegnNo) {
      toast.error('Vehicle Registration Number can not be empty');
      return false;
    } else if (leadMotorDetails?.VehicleRegnNo.trim().length > 20) {
      toast.error('Vehicle Registration Number cannot exceed 20 characters');
      return false;
    } else if (!isValidVehicleNumber(leadMotorDetails?.VehicleRegnNo)) {
      toast.error('Enter valid Vehicle Registration Number');
      return false;
    } else if (!locationData?.pincode) {
      toast.error('Pincode can not be empty.');
      return false;
    } else if (!locationData?.zone) {
      toast.info('Zone name can not be empty');
      return false;
    } else if (!locationData?.state) {
      toast.info('State name can not be empty');
      return false;
    } else if (!locationData?.district) {
      toast.info('District name can not be empty');
      return false;
    } else if (!locationData?.city) {
      toast.info('Village name can not be empty');
      return false;
    } else if (
      leadMotorDetails?.AadharNumber &&
      !/^[2-9]\d{11}$/.test(leadMotorDetails?.AadharNumber)
    ) {
      toast.error('Enter valid Aadhaar Number');
      return false;
    } else if (!leadMotorDetails?.date) {
      toast.error('Date of Birth cannot be a empty');
      return false;
    } else if (
      leadMotorDetails?.date &&
      moment(leadMotorDetails?.date).isAfter(moment(), 'day')
    ) {
      toast.error('Date of Birth cannot be a future date');
      return false;
    } else if (!leadMotorDetails?.timeframeOfPurchase) {
      toast.error('Timeframe of Purchase cannot be empty');
      return false;
    } else if (
      leadMotorDetails?.everInsured &&
      !['yes', 'no'].includes(leadMotorDetails?.everInsured)
    ) {
      toast.error('Please select a valid Ever Insured option');
      return false;
    } else if (
      leadMotorDetails?.additionalInformation &&
      leadMotorDetails?.additionalInformation.trim().length > 500
    ) {
      toast.error('Additional Information cannot exceed 500 characters');
      return false;
    }

    return true;
  };

  const validateOtherLead = async (): Promise<boolean> => {
    const allZerosRegex = /^0+$/;
    const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
    const isValidName = (name: any) => {
      return (
        TEXT_ONLY_REGEX.test(name) &&
        name.trim().length >= 2 &&
        name.trim().length <= 100
      );
    };
    const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

    if (
      !leadOtherDetails?.firstname ||
      !isValidName(leadOtherDetails?.firstname)
    ) {
      toast.error('Enter valid lead First Name');
      return false;
    } else if (
      !leadOtherDetails?.lastname ||
      !isValidName(leadOtherDetails?.lastname)
    ) {
      toast.error('Enter valid lead Last Name');
      return false;
    } else if (!numberRegex.test(leadOtherDetails?.contactNumber)) {
      toast.error('Enter valid contact Number');
      return false;
    } else if (allZerosRegex.test(leadOtherDetails?.contactNumber)) {
      toast.error('Contact number cannot consist of all zeros.');
      return false;
    } else if (leadOtherDetails?.contactNumber.length !== 10) {
      toast.info('Contact Number must be 10 digits.');
      return false;
    } else if (!/^\d+$/.test(leadOtherDetails?.contactNumber)) {
      toast.error('Contact Number should only contain digits');
      return false;
    } else if (
      leadOtherDetails?.alternateContactNumber &&
      !numberRegex.test(leadOtherDetails?.alternateContactNumber)
    ) {
      toast.error('Enter valid Alternate contact Number');
      return false;
    } else if (
      leadOtherDetails?.alternateContactNumber &&
      allZerosRegex.test(leadOtherDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact number cannot consist of all zeros.');
      return false;
    } else if (
      leadOtherDetails?.alternateContactNumber &&
      leadOtherDetails?.alternateContactNumber.length !== 10
    ) {
      toast.info('Alternate Contact Number must be 10 digits.');
      return false;
    } else if (
      leadOtherDetails?.alternateContactNumber &&
      !/^\d+$/.test(leadOtherDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact Number should only contain digits');
      return false;
    } else if (!leadOtherDetails?.interestedFor) {
      toast.error('Intrested For can not be empty');
      return false;
    } else if (!locationData?.pincode) {
      toast.error('Pincode can not be empty.');
      return false;
    } else if (!locationData?.zone) {
      toast.info('Zone name can not be empty');
      return false;
    } else if (!locationData?.state) {
      toast.info('State name can not be empty');
      return false;
    } else if (!locationData?.district) {
      toast.info('District name can not be empty');
      return false;
    } else if (!locationData?.city) {
      toast.info('Village name can not be empty');
      return false;
    } else if (
      leadOtherDetails?.AadharNumber &&
      !/^[2-9]\d{11}$/.test(leadOtherDetails?.AadharNumber)
    ) {
      toast.error('Enter valid Aadhaar Number');
      return false;
    } else if (
      leadOtherDetails?.date &&
      moment(leadOtherDetails?.date).isAfter(moment(), 'day')
    ) {
      toast.error('Date of Birth cannot be a future date');
      return false;
    } else if (!leadOtherDetails?.timeframeOfPurchase) {
      toast.error('Timeframe of Purchase cannot be empty');
      return false;
    } else if (
      leadOtherDetails?.everInsured &&
      !['yes', 'no'].includes(leadOtherDetails?.everInsured)
    ) {
      toast.error('Please select a valid Ever Insured option');
      return false;
    } else if (
      leadOtherDetails?.additionalInformation &&
      leadOtherDetails?.additionalInformation.trim().length > 500
    ) {
      toast.error('Additional Information cannot exceed 500 characters');
      return false;
    }

    return true;
  };

  const validateHealthLead = async (): Promise<boolean> => {
    const allZerosRegex = /^0+$/;
    const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
    const isValidName = (name: any) => {
      return (
        TEXT_ONLY_REGEX.test(name) &&
        name.trim().length >= 2 &&
        name.trim().length <= 100
      );
    };
    const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

    if (
      !leadHealthDetails?.firstname ||
      !isValidName(leadHealthDetails?.firstname)
    ) {
      toast.error('Enter valid lead First Name');
      return false;
    } else if (
      !leadHealthDetails?.lastname ||
      !isValidName(leadHealthDetails?.lastname)
    ) {
      toast.error('Enter valid lead Last Name');
      return false;
    } else if (!numberRegex.test(leadHealthDetails?.contactNumber)) {
      toast.error('Enter valid contact Number');
      return false;
    } else if (allZerosRegex.test(leadHealthDetails?.contactNumber)) {
      toast.error('Contact number cannot consist of all zeros.');
      return false;
    } else if (leadHealthDetails?.contactNumber.length !== 10) {
      toast.info('Contact Number must be 10 digits.');
      return false;
    } else if (!/^\d+$/.test(leadHealthDetails?.contactNumber)) {
      toast.error('Contact Number should only contain digits');
      return false;
    } else if (
      leadHealthDetails?.alternateContactNumber &&
      !numberRegex.test(leadHealthDetails?.alternateContactNumber)
    ) {
      toast.error('Enter valid Alternate contact Number');
      return false;
    } else if (
      leadHealthDetails?.alternateContactNumber &&
      allZerosRegex.test(leadHealthDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact number cannot consist of all zeros.');
      return false;
    } else if (
      leadHealthDetails?.alternateContactNumber &&
      leadHealthDetails?.alternateContactNumber.length !== 10
    ) {
      toast.info('Alternate Contact Number must be 10 digits.');
      return false;
    } else if (
      leadHealthDetails?.alternateContactNumber &&
      !/^\d+$/.test(leadHealthDetails?.alternateContactNumber)
    ) {
      toast.error('Alternate Contact Number should only contain digits');
      return false;
    } else if (!leadHealthDetails?.typeofCover) {
      toast.error('Type of Cover can not be empty');
      return false;
    } else if (!leadHealthDetails?.coverage) {
      toast.error('Coverage can not be empty');
      return false;
    } else if (!leadHealthDetails?.coverageFor) {
      toast.error('Coverage For can not be empty');
      return false;
    } else if (!locationData?.pincode) {
      toast.error('Pincode can not be empty.');
      return false;
    } else if (!locationData?.zone) {
      toast.info('Zone name can not be empty');
      return false;
    } else if (!locationData?.state) {
      toast.info('State name can not be empty');
      return false;
    } else if (!locationData?.district) {
      toast.info('District name can not be empty');
      return false;
    } else if (!locationData?.city) {
      toast.info('Village name can not be empty');
      return false;
    } else if (
      leadHealthDetails?.AadharNumber &&
      !/^[2-9]\d{11}$/.test(leadHealthDetails?.AadharNumber)
    ) {
      toast.error('Enter valid Aadhaar Number');
      return false;
    } else if (!leadHealthDetails?.date) {
      toast.error('Date of Birth cannot be a empty');
      return false;
    } else if (
      leadHealthDetails?.date &&
      moment(leadHealthDetails?.date).year() < 1900
    ) {
      toast.error('Date of Birth should be from 1900 onwards');
      return false;
    } else if (
      leadHealthDetails?.date &&
      moment(leadHealthDetails?.date).isAfter(moment(), 'day')
    ) {
      toast.error('Date of Birth cannot be a future date');
      return false;
    } else if (!moment(leadHealthDetails?.date).isValid()) {
      toast.error('Enter valid Date of Birth');
      return false;
    } else if (!leadHealthDetails?.timeframeOfPurchase) {
      toast.error('Timeframe of Purchase cannot be empty');
      return false;
    } else if (
      leadHealthDetails?.everInsured &&
      !['yes', 'no'].includes(leadHealthDetails?.everInsured)
    ) {
      toast.error('Please select a valid Ever Insured option');
      return false;
    } else if (
      leadHealthDetails?.additionalInformation &&
      leadHealthDetails?.additionalInformation.trim().length > 500
    ) {
      toast.error('Additional Information cannot exceed 500 characters');
      return false;
    }

    return true;
  };

  const handleAddLead = async () => {
    const isValid = await validateLead();

    if (!isValid) {
      return;
    }

    console.log('locationData', leadDetails, locationData);

    setLeadList((prev) => [
      ...prev,
      {
        id: Date.now(),
        ...leadDetails,
        ...selectedLeadData,
        state: Number(locationData.state),
        district: Number(locationData.district),
        city: Number(locationData.city),
        zone: Number(locationData.zone),
        pincode: locationData.pincode,
        zoneName,
        stateName,
        districtName,
        villageName,
        remove: 'Remove',
      },
    ]);
    console.log('villageName', villageName);
    // Clear inputs after adding
    setLeadDetails({
      name: '',
      contactNumber: '',
    });
    setSelectedLeadData({
      productId: '',
      cropName: '',
      loanAmount: '',
    });
    setLocationData(blankLocation);
    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);
    setSelectedPincodeData({
      label: '',
      value: '',
    });
  };
  const handleRemoveLead = (id: number) => {
    setLeadList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };

  return (
    <div>
      <Label className="text-heading">{title ?? 'Create Lead'}</Label>
      <div className="container-parent task-item-parent-view">
        <Row className="task-details pb-2">
          <Col xs={12} md={4}>
            <MTextField
              label="Lead Id"
              value={leadUniqueId}
              onChange={(event) => {
                setLeadUniqueId(event.target.value);
              }}
              disabled
            />
          </Col>

          {(selectedLeadTypeId && selectedLeadTypeId != 1) ||
          !selectedLeadTypeId ? (
            <Col xs={12} md={4} className="col-margin">
              <MSelect
                label="LOB Type"
                required
                disabled={disabled}
                options={leadTypeLOBOptions}
                value={lobName}
                onChange={async (e) => {
                  await clearFields();
                  setLobName(e.target.value);
                  await dispatch(
                    fetchLeadTypeDrops({ lobId: Number(e.target.value) })
                  );
                }}
              />
            </Col>
          ) : null}

          <Col xs={12} md={4} className="col-margin">
            <MSelect
              label="Lead Type"
              required
              disabled={
                leadStatus === TASK_ACTION.CREATE && !lobName ? true : disabled
              }
              options={leadTypeDropOptions}
              value={selectedLeadTypeId}
              onChange={onTaskNameChange}
            />
          </Col>
        </Row>
        {(!selectedLeadTypeId || selectedLeadTypeId) &&
        leadStatus != TASK_ACTION.CREATE ? (
          <div className="inner-div mt-2">
            <Label className="header-style">Assigned To</Label>
            <Row className="mt-1">
              <Col
                xs={!leadStatus || leadStatus === TASK_ACTION.CREATE ? 12 : 7}
                md={4}
              >
                <MAutoComplete
                  label="Employee Name"
                  options={optionEmployeeName}
                  value={{
                    value: selectedEmployee.candidateId,
                    label: selectedEmployee.employeeName.trim(),
                  }}
                  onChange={(value: any) => {
                    updateSelectedEmployee(
                      value,
                      employeeList,
                      setSelectedEmployee
                    );
                  }}
                  icon={<Image src={Search}></Image>}
                />
              </Col>
              {leadStatus !== TASK_ACTION.CREATE && (
                <Col xs={4} md={4}>
                  <Button
                    variant="primary"
                    className="cl-btn-primary mt-2 assign-button"
                    disabled={
                      showLoader ||
                      (selectedEmployee?.candidateId ?? '') ===
                        (leadToViewDetails?.assignedToEmployeeUniqueId ?? '')
                    }
                    onClick={() => {
                      assignTask(
                        {
                          leadId: leadUniqueId,
                          assignedToId: selectedEmployee.candidateId || null,
                        },
                        setShowLoader,
                        dispatch,
                        handleLeadsData,
                        setLeadToViewDetails
                      );
                    }}
                  >
                    Assign Lead
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={4}>
                <MTextField
                  label="Role"
                  value={selectedEmployee?.roleName}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      roleName: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Employee Id"
                  value={selectedEmployee?.employeeUniqueId}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      employeeUniqueId: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Mobile Number"
                  value={selectedEmployee?.mobileNumber}
                  onChange={(event: any) => {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      mobileNumber: event.target.value,
                    });
                  }}
                  disabled
                />
              </Col>
            </Row>
          </div>
        ) : null}
        {selectedLeadTypeId && selectedLeadTypeId == 3 ? (
          <div className="inner-div">
            <Row className="align-items-center mb-3">
              <Col xs={6}>
                <Label className="header-style mb-0">Lead Details</Label>
              </Col>

              {leadStatus == TASK_ACTION.CREATE && (
                <Col xs={6} className="text-end">
                  <Button
                    variant="primary"
                    onClick={handleAddLead}
                    disabled={disabled}
                  >
                    Add Lead
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="mt-1">
              <Col xs={12} md={4}>
                <MTextField
                  label="Lead Name"
                  required
                  value={leadDetails.name}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setLeadDetails({
                      ...leadDetails,
                      name: inputValue,
                    });
                  }}
                  disabled={disabled}
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Contact Number"
                  required
                  value={leadDetails.contactNumber}
                  onChange={(data) => {
                    if (data.target.value.length <= 10) {
                      setLeadDetails({
                        ...leadDetails,
                        contactNumber: data.target.value,
                      });
                    }
                  }}
                  disabled={disabled}
                />
              </Col>
              <Col xs={12} md={4}>
                <MSelect
                  label="Product"
                  required
                  disabled={disabled}
                  options={leadProductTypeDropOptions}
                  value={selectedLeadData.productId}
                  onChange={(e) => {
                    setSelectedLeadData({
                      ...selectedLeadData,
                      productId: e.target.value,
                    });
                  }}
                />
              </Col>
              <Col xs={12} md={4} className="mt-4">
                <MTextField
                  label="Crop"
                  value={selectedLeadData.cropName}
                  onChange={(e) => {
                    setSelectedLeadData({
                      ...selectedLeadData,
                      cropName: e.target.value,
                    });
                  }}
                  disabled={disabled}
                />
              </Col>
              <Col xs={12} md={4} className="mt-4">
                <MTextField
                  label="Loan Amount"
                  value={selectedLeadData.loanAmount}
                  onChange={(e) => {
                    setSelectedLeadData({
                      ...selectedLeadData,
                      loanAmount: e.target.value,
                    });
                  }}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Col xs={12} md={5}>
                {leadStatus == TASK_ACTION.CREATE ? (
                  <Autocomplete
                    open={ifPincode}
                    onOpen={() => setIfPincode(true)}
                    onClose={() => setIfPincode(false)}
                    options={pincodeData}
                    getOptionLabel={(option) => String(option?.label)}
                    value={selectedPincodeData ?? null}
                    inputValue={inputValue}
                    onInputChange={(event, newValue, reason) => {
                      if (reason !== 'reset') {
                        const safeValue =
                          typeof newValue === 'string' ? newValue : '';
                        console.log('safeValue', safeValue);
                        setInputValue(safeValue);
                      }
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={async (event, newValue) => {
                      console.log('newValue', newValue);
                      if (newValue) {
                        const validZoneIds =
                          (await zoneOption.map((zone) => zone.value)) || [];
                        const validStateIds =
                          (await Object.values(allStates).flatMap((group) =>
                            group.map((item) => item.value)
                          )) || [];
                        const districtsLength =
                          (await Object.keys(districtData).length) ?? 0;
                        if (
                          !validZoneIds.includes(String(newValue.zoneId)) ||
                          !validStateIds.includes(String(newValue.stateId)) ||
                          districtsLength == 0
                        ) {
                          alert(
                            'This location isn’t within your assigned region'
                          );
                          setInputValue('');
                          setPincodeData([]);
                          setLocationData(blankLocation);
                          return;
                        }
                        setSearchTerm(true);
                        setSelectedPincodeData(newValue);
                        setLocationData({
                          ...locationData,
                          zone: newValue.zoneId,
                          state: newValue.stateId,
                          district: newValue.districtId,
                          city: newValue.villageId,
                          pincode: newValue.pincode,
                        });
                        setZoneName(newValue.zoneName);
                        setStateName(newValue.stateName);
                        setDistrictName(newValue.districtName);
                        setVillageName(
                          newValue.mandalName
                            ? newValue.mandalName + '-' + newValue.villageName
                            : newValue.villageName
                        );
                      } else {
                        setInputValue('');
                        setPincodeData([]);
                        setLocationData(blankLocation);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Pincode"
                        InputLabelProps={{
                          style: { fontSize: '0.8rem' },
                        }}
                        error={
                          inputValue !== '' &&
                          (!/^\d{6}$/.test(inputValue) ||
                            Number(inputValue) < 100001 ||
                            Number(inputValue) > 999999)
                        }
                        helperText={
                          inputValue !== '' &&
                          (!/^\d{6}$/.test(inputValue) ||
                            Number(inputValue) < 100001 ||
                            Number(inputValue) > 999999)
                            ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                            : ''
                        }
                        variant="outlined"
                        id="searchPincode"
                        required
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              <InputAdornment position="end">
                                <IconButton onClick={handleSearchClick}>
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            </>
                          ),
                        }}
                      />
                    )}
                    disabled={false}
                  />
                ) : (
                  <MTextField
                    label="Pincode"
                    required
                    value={locationData.pincode ?? ''}
                    numberOnly
                    disabled
                  />
                )}
              </Col>
            </Row>
            <div className="mt-4">
              <MUILocationFilter
                size={{
                  zone: colSize,
                  state: colSize,
                  district: colSize,
                  city: colSize,
                }}
                filterData={{
                  zone: locationData.zone,
                  state: locationData.state,
                  district: locationData.district,
                  city: locationData.city,
                }}
                setLocationFilter={(filter: MUILocationFilterType) => {
                  setLocationData({
                    ...locationData,
                    zone: filter.zone,
                    state: filter.state,
                    district: filter.district,
                    city: filter.city,
                    pincode: filter.pincode ?? '',
                  });
                }}
                disabled={disabled}
                required={true}
                defaultLocationOptions={defaultLocationOptions}
                selectedLeadTypeId={selectedLeadTypeId}
                setZoneName={(data) => setZoneName(data)}
                setStateName={(data) => setStateName(data)}
                setDistrictName={(data) => setDistrictName(data)}
                setVillageName={(data) => setVillageName(data)}
                setInputValue={(data: any) => {
                  setInputValue(String(data));
                }}
                searchTerm={searchTerm}
                setSearchTerm={(data: any) => {
                  setSearchTerm(data);
                }}
              />
            </div>
            {leadList.length > 0 ? (
              <Row className="mt-4">
                <Col xs={12} md={12}>
                  <KTable
                    data={leadList}
                    tableParentClass=""
                    columnHeader={VIEW_LEADDETAILS_HEADER}
                    isLoading={false}
                    showNoDataFoundMsg={false}
                    onAction={(action, rowData) => {
                      if (rowData?.action === CLICK_ACTIONS.DELETE) {
                        handleRemoveLead(action.id);
                      }
                    }}
                  />
                </Col>
              </Row>
            ) : null}
          </div>
        ) : selectedLeadTypeId &&
          (selectedLeadTypeId == 4 || selectedLeadTypeId == 8) ? (
          <CropSectionPage
            leadStatus={leadStatus}
            disabled={disabled}
            selectedLeadTypeId={selectedLeadTypeId}
            leadCropDetails={leadCropDetails}
            setLeadCropDetails={(data: any) => {
              setLeadCropDetails(data);
            }}
            leadCropList={leadCropList}
            setLeadCropList={(data: any) => {
              setLeadCropList(data);
            }}
            defaultLocationOptions={defaultLocationOptions}
            zoneName={zoneName}
            stateName={stateName}
            districtName={districtName}
            villageName={villageName}
            locationData={locationData}
            inputValue={inputValue}
            searchTerm={searchTerm}
            ifPincode={ifPincode}
            pincodeData={pincodeData}
            selectedPincodeData={selectedPincodeData}
            setZoneName={(data: any) => setZoneName(data)}
            setStateName={(data: any) => setStateName(data)}
            setDistrictName={(data: any) => setDistrictName(data)}
            setVillageName={(data: any) => setVillageName(data)}
            setLocationData={(data: any) => setLocationData(data)}
            setInputValue={(data: any) => setInputValue(data)}
            setSearchTerm={(data: any) => setSearchTerm(data)}
            setIfPincode={(data: any) => setIfPincode(data)}
            setPincodeData={(data: any) => setPincodeData(data)}
            setSelectedPincodeData={(data: any) => setSelectedPincodeData(data)}
            leadBankTypeDropOptions={leadBankTypeDropOptions}
            validateCropLead={validateCropLead}
          />
        ) : selectedLeadTypeId && selectedLeadTypeId == 6 ? (
          <MotorSectionPage
            leadStatus={leadStatus}
            disabled={disabled}
            selectedLeadTypeId={selectedLeadTypeId}
            leadMotorDetails={leadMotorDetails}
            setLeadMotorDetails={(data: any) => {
              setLeadMotorDetails(data);
            }}
            leadMotorList={leadMotorList}
            setLeadMotorList={(data: any) => {
              setLeadMotorList(data);
            }}
            defaultLocationOptions={defaultLocationOptions}
            zoneName={zoneName}
            stateName={stateName}
            districtName={districtName}
            villageName={villageName}
            locationData={locationData}
            inputValue={inputValue}
            searchTerm={searchTerm}
            ifPincode={ifPincode}
            pincodeData={pincodeData}
            selectedPincodeData={selectedPincodeData}
            setZoneName={(data: any) => setZoneName(data)}
            setStateName={(data: any) => setStateName(data)}
            setDistrictName={(data: any) => setDistrictName(data)}
            setVillageName={(data: any) => setVillageName(data)}
            setLocationData={(data: any) => setLocationData(data)}
            setInputValue={(data: any) => setInputValue(data)}
            setSearchTerm={(data: any) => setSearchTerm(data)}
            setIfPincode={(data: any) => setIfPincode(data)}
            setPincodeData={(data: any) => setPincodeData(data)}
            setSelectedPincodeData={(data: any) => setSelectedPincodeData(data)}
            validateMotorLead={validateMotorLead}
          />
        ) : selectedLeadTypeId && selectedLeadTypeId == 5 ? (
          <HealthSectionPage
            leadStatus={leadStatus}
            disabled={disabled}
            selectedLeadTypeId={selectedLeadTypeId}
            leadHealthDetails={leadHealthDetails}
            setLeadHealthDetails={(data: any) => {
              setLeadHealthDetails(data);
            }}
            leadHealthList={leadHealthList}
            setLeadHealthList={(data: any) => {
              setLeadHealthList(data);
            }}
            defaultLocationOptions={defaultLocationOptions}
            zoneName={zoneName}
            stateName={stateName}
            districtName={districtName}
            villageName={villageName}
            locationData={locationData}
            inputValue={inputValue}
            searchTerm={searchTerm}
            ifPincode={ifPincode}
            pincodeData={pincodeData}
            selectedPincodeData={selectedPincodeData}
            setZoneName={(data: any) => setZoneName(data)}
            setStateName={(data: any) => setStateName(data)}
            setDistrictName={(data: any) => setDistrictName(data)}
            setVillageName={(data: any) => setVillageName(data)}
            setLocationData={(data: any) => setLocationData(data)}
            setInputValue={(data: any) => setInputValue(data)}
            setSearchTerm={(data: any) => setSearchTerm(data)}
            setIfPincode={(data: any) => setIfPincode(data)}
            setPincodeData={(data: any) => setPincodeData(data)}
            setSelectedPincodeData={(data: any) => setSelectedPincodeData(data)}
            validateHealthLead={validateHealthLead}
          />
        ) : selectedLeadTypeId && selectedLeadTypeId == 7 ? (
          <OtherSectionPage
            leadStatus={leadStatus}
            disabled={disabled}
            selectedLeadTypeId={selectedLeadTypeId}
            leadOtherDetails={leadOtherDetails}
            setLeadOtherDetails={(data: any) => {
              setLeadOtherDetails(data);
            }}
            leadOtherList={leadOtherList}
            setLeadOtherList={(data: any) => {
              setLeadOtherList(data);
            }}
            defaultLocationOptions={defaultLocationOptions}
            zoneName={zoneName}
            stateName={stateName}
            districtName={districtName}
            villageName={villageName}
            locationData={locationData}
            inputValue={inputValue}
            searchTerm={searchTerm}
            ifPincode={ifPincode}
            pincodeData={pincodeData}
            selectedPincodeData={selectedPincodeData}
            setZoneName={(data: any) => setZoneName(data)}
            setStateName={(data: any) => setStateName(data)}
            setDistrictName={(data: any) => setDistrictName(data)}
            setVillageName={(data: any) => setVillageName(data)}
            setLocationData={(data: any) => setLocationData(data)}
            setInputValue={(data: any) => setInputValue(data)}
            setSearchTerm={(data: any) => setSearchTerm(data)}
            setIfPincode={(data: any) => setIfPincode(data)}
            setPincodeData={(data: any) => setPincodeData(data)}
            setSelectedPincodeData={(data: any) => setSelectedPincodeData(data)}
            validateOtherLead={validateOtherLead}
          />
        ) : (
          <div className="inner-div">
            <Label className="header-style">Lead Details</Label>
            <Row className="mt-1">
              <Col xs={12} md={4}>
                <MTextField
                  label="Lead Name"
                  required
                  value={leadDetails.name}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setLeadDetails({
                      ...leadDetails,
                      name: inputValue,
                    });
                  }}
                  disabled={disabled}
                />
              </Col>
              <Col xs={12} md={4} className="col-margin">
                <MTextField
                  label="Contact Number"
                  required
                  value={leadDetails.contactNumber}
                  onChange={(data) => {
                    if (data.target.value.length <= 10) {
                      setLeadDetails({
                        ...leadDetails,
                        contactNumber: data.target.value,
                      });
                    }
                  }}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <div className="mt-4">
              <MUILocationFilter
                size={{
                  zone: colSize,
                  state: colSize,
                  district: colSize,
                  city: colSize,
                }}
                filterData={{
                  zone: locationData.zone,
                  state: locationData.state,
                  district: locationData.district,
                  city: locationData.city,
                }}
                setLocationFilter={(filter: MUILocationFilterType) => {
                  setLocationData({
                    ...locationData,
                    zone: filter.zone,
                    state: filter.state,
                    district: filter.district,
                    city: filter.city,
                    pincode: filter.pincode ?? '',
                  });
                }}
                disabled={disabled}
                required={true}
                defaultLocationOptions={defaultLocationOptions}
              />
            </div>
            <Row className="mt-4">
              <Col xs={12} md={3}>
                <MTextField
                  label="Pincode"
                  required
                  value={locationData.pincode ?? ''}
                  numberOnly
                  disabled
                />
              </Col>
            </Row>
          </div>
        )}

        {selectedLeadTypeId && selectedLeadTypeId == 3 ? (
          <div className="inner-div">
            <Label className="header-style">Branch Lead Details</Label>
            <Row className="mt-3">
              <Col xs={12} md={4}>
                <MTextField
                  label="Branch Manager Name"
                  value={rmName}
                  onChange={(e) => {
                    setRMName(e.target.value);
                  }}
                  disabled={disabled}
                />
              </Col>

              <Col xs={12} md={4}>
                <MTextField
                  label="Branch Manager Contact Number"
                  value={rmMobileNum}
                  onChange={(data) => {
                    if (data.target.value.length <= 10) {
                      setRMMobileNumber(data.target.value);
                    }
                  }}
                  disabled={disabled}
                />
              </Col>

              <Col xs={12} md={4}>
                <MSelect
                  label="Bank Name"
                  required
                  disabled={disabled}
                  options={leadBankTypeDropOptions}
                  value={selectedBank ?? ''}
                  onChange={(e) => {
                    const bankId = Number(e.target.value);
                    setSelectedBank(bankId);
                    dispatch(fetchLeadTypeBranchDrops({ bankId }));
                  }}
                />
              </Col>

              <Col xs={12} md={4} className="mt-4">
                <MSelect
                  label="Branch Name"
                  required
                  disabled={disabled}
                  options={leadBranchTypeDropOptions}
                  value={selectedBranch ?? ''}
                  onChange={(e) => {
                    setSelectedBranch(Number(e.target.value));
                  }}
                />
              </Col>
            </Row>
          </div>
        ) : null}
        <div className="inner-div">
          <Label className="header-style">Others</Label>
          <Row className="mt-1">
            <Col xs={12} md={6} className="task-date-picker">
              <MDatePicker
                label="Registration Date and Time"
                value={completionDateTime}
                onChange={setCompletionDateTime}
                disabled={
                  leadStatus && leadStatus === TASK_ACTION.CREATE
                    ? true
                    : disabled
                }
                icon={<Image src={Calendar}></Image>}
                maxDate={moment()}
              />
            </Col>
            <Col xs={12} md={6} className="col-margin">
              <MSelect
                label="Status of the Lead"
                disabled={
                  leadStatus === TASK_ACTION.CREATE ||
                  selectedLeadTypeId == 3 ||
                  selectedLeadTypeId == 4 ||
                  selectedLeadTypeId == 5 ||
                  selectedLeadTypeId == 6 ||
                  selectedLeadTypeId == 7 ||
                  selectedLeadTypeId == 8
                }
                options={statusDropOptions}
                onChange={(e) => {
                  setOptionTaskStatus(e.target.value);
                }}
                value={optionTaskStatus ?? ''}
              />
            </Col>
          </Row>
        </div>

        {leadStatus &&
          (leadStatus === TASK_ACTION.ASSIGN ||
            leadStatus === TASK_ACTION.VIEW) && (
            <Row className="mb-5">
              <Col xs={12} md={6} className="activity-log-margin">
                <Label className="model-comment-title mt-2 activity-level">
                  Activity Log
                </Label>
                <div className="activity-log-div">
                  <ul className="ul-item task-log-value">
                    {leadToViewDetails?.notes.map((noteItem) => (
                      <li
                        className="mt-1"
                        key={`notes-${noteItem.notesid ?? noteItem.notesId}`}
                      >
                        {getNoteDate(noteItem)}
                        {noteItem.notesDescription}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              <Col xs={12} md={6} className="activity-log-margin create-input">
                <div className="mb-2">
                  <Label for="comment" className="model-comment-title mt-2">
                    Comments
                  </Label>
                  <Input
                    id="comment"
                    name="comment"
                    type="textarea"
                    value={comment}
                    maxLength={250}
                    className="rounded border model-comment-area comment-input"
                    onChange={(event) => {
                      setComment(event.target.value);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <Image
                    className="me-2 cursor-pointer"
                    src={Cancel}
                    onClick={() => {
                      setComment('');
                    }}
                  />
                  {'    '}
                  <Image
                    alt="imgSaveComment"
                    className="me-2 cursor-pointer"
                    src={
                      showLoader || !comment ? DisablesuccessTick : successTick
                    }
                    onClick={() => {
                      if (!(showLoader || !comment))
                        saveComment(
                          {
                            comment,
                            leadUniqueId,
                            leadToViewDetails,
                          },
                          setShowLoader,
                          dispatch,
                          setLeadToViewDetails,
                          handleLeadsData,
                          setComment
                        );
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}

        {(!leadStatus || leadStatus === TASK_ACTION.CREATE) && (
          <Row>
            <Col xs={12} md={6} className="create-comment-parent">
              <FormGroup className="comment-input">
                <Label for="comment" className="model-comment-title mt-2">
                  Comments
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  value={comment}
                  maxLength={250}
                  className="rounded border model-comment-area comment-input"
                  onChange={(event) => {
                    setComment(event.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        <div className="d-flex justify-content-center bottom-button">
          <Button
            variant="primary"
            className="cl-btn-primary-custom mt-2"
            disabled={
              showLoader ||
              (leadStatus !== TASK_ACTION.CREATE &&
                optionTaskStatus === leadToViewDetails?.leadStatus)
            }
            onClick={async () => {
              if (leadStatus === TASK_ACTION.CREATE) {
                console.log('leadList', leadList);

                if (selectedLeadTypeId && selectedLeadTypeId == 3) {
                  const hasData =
                    leadDetails?.name ||
                    leadDetails?.contactNumber ||
                    selectedLeadData?.productId ||
                    locationData?.pincode;

                  const mapLead = (lead: any) => ({
                    leadName: lead.name,
                    leadNumber: lead.contactNumber,
                    state: Number(lead.state),
                    district: Number(lead.district),
                    city: Number(lead.city),
                    zone: Number(lead.zone),
                    pincode: lead.pincode,
                    crop: lead.cropName,
                    productId: lead.productId,
                    loanAmt: lead.loanAmount,
                  });

                  const leadListPayload = await leadList.map(mapLead);

                  // Handle Lead Type 3 special case
                  if (
                    selectedLeadTypeId &&
                    selectedLeadTypeId == 3 &&
                    hasData
                  ) {
                    const isValid = await validateLead();

                    if (!isValid) {
                      return;
                    }

                    leadListPayload.push({
                      leadName: leadDetails.name,
                      leadNumber: leadDetails.contactNumber,
                      state: Number(locationData.state),
                      district: Number(locationData.district),
                      city: Number(locationData.city),
                      zone: Number(locationData.zone),
                      pincode: locationData.pincode,
                      crop: selectedLeadData.cropName,
                      productId: selectedLeadData.productId,
                      loanAmt: selectedLeadData.loanAmount,
                    });
                  }

                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                } else if (
                  (selectedLeadTypeId && selectedLeadTypeId == 4) ||
                  (selectedLeadTypeId && selectedLeadTypeId == 8)
                ) {
                  const hasData =
                    leadCropDetails?.firstname ||
                    leadCropDetails?.contactNumber ||
                    leadCropDetails?.loaneeStatus ||
                    leadCropDetails.tenantStatus ||
                    leadCropDetails?.surveyNumber ||
                    leadCropDetails?.subSurveyNumber ||
                    leadCropDetails?.timeframeOfPurchase ||
                    locationData?.pincode;

                  const mapLead = (lead: any) => ({
                    leadName: lead.firstname + ' ' + lead.lastname,
                    leadNumber: lead.contactNumber,
                    state: Number(lead.state),
                    district: Number(lead.district),
                    city: Number(lead.city),
                    zone: Number(lead.zone),
                    pincode: lead.pincode,
                    productId: null,
                    cropLobLeadReq: {
                      firstName: lead.firstname,
                      lastName: lead.lastname,
                      alternateMobileNumber: lead.alternateContactNumber,
                      loaneeStatus: lead.loaneeStatus,
                      bankId: lead.bankName,
                      branchId: lead.branchName,
                      tenantStatus: lead.tenantStatus,
                      surveyNumber: lead.surveyNumber,
                      subSurveyNumber: lead.subSurveyNumber,
                      timeframeOfPurchase: moment(
                        lead.timeframeOfPurchase
                      ).format('YYYY-MM-DD'),
                      pastInsurance: lead.pastInsurance,
                      insuredArea: lead.insuredArea,
                      areaDec: lead.areaDec,
                    },
                  });

                  const leadListPayload = await leadCropList.map(mapLead);

                  // Handle Lead Type 3 special case
                  if (
                    selectedLeadTypeId &&
                    (selectedLeadTypeId == 4 || selectedLeadTypeId == 8) &&
                    hasData
                  ) {
                    const isValid = await validateCropLead();

                    if (!isValid) {
                      return;
                    }

                    leadListPayload.push({
                      leadName:
                        leadCropDetails.firstname +
                        ' ' +
                        leadCropDetails.lastname,
                      leadNumber: leadCropDetails.contactNumber,
                      state: Number(locationData.state),
                      district: Number(locationData.district),
                      city: Number(locationData.city),
                      zone: Number(locationData.zone),
                      pincode: locationData.pincode,
                      productId: null,
                      cropLobLeadReq: {
                        firstName: leadCropDetails.firstname,
                        lastName: leadCropDetails.lastname,
                        alternateMobileNumber:
                          leadCropDetails.alternateContactNumber,
                        loaneeStatus: leadCropDetails.loaneeStatus,
                        bankId: leadCropDetails.bankName,
                        branchId: leadCropDetails.branchName,
                        tenantStatus: leadCropDetails.tenantStatus,
                        surveyNumber: leadCropDetails.surveyNumber,
                        subSurveyNumber: leadCropDetails.subSurveyNumber,
                        timeframeOfPurchase: moment(
                          leadCropDetails.timeframeOfPurchase
                        ).format('YYYY-MM-DD'),
                        pastInsurance: leadCropDetails.pastInsurance,
                        insuredArea: leadCropDetails.insuredArea,
                        areaDec: leadCropDetails.areaDec,
                      },
                    });
                  }

                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                } else if (selectedLeadTypeId && selectedLeadTypeId == 5) {
                  const hasData =
                    leadHealthDetails?.firstname ||
                    leadHealthDetails?.lastname ||
                    leadHealthDetails?.contactNumber ||
                    leadHealthDetails?.alternateContactNumber ||
                    leadHealthDetails?.typeofCover ||
                    leadHealthDetails?.coverage ||
                    leadHealthDetails?.coverageFor ||
                    leadHealthDetails?.AadharNumber ||
                    leadHealthDetails?.date ||
                    leadHealthDetails?.timeframeOfPurchase ||
                    leadHealthDetails?.everInsured ||
                    leadHealthDetails?.additionalInformation ||
                    locationData?.pincode;

                  const mapLead = (lead: any) => ({
                    leadName: lead.firstname + ' ' + lead.lastname,
                    leadNumber: lead.contactNumber,
                    state: Number(lead.state),
                    district: Number(lead.district),
                    city: Number(lead.city),
                    zone: Number(lead.zone),
                    pincode: lead.pincode,
                    productId: null,
                    healthLobLeadReq: {
                      firstName: lead.firstname,
                      lastName: lead.lastname,
                      alternateMobileNumber: lead.alternateContactNumber,
                      typeOfCoverId: lead.typeofCover,
                      coverageId: lead.coverage,
                      coverageForId: lead.coverageFor,
                      aadhaarNumber: lead.AadharNumber,
                      dateOfBirth: lead?.date
                        ? moment(lead.date).format('YYYY-MM-DD')
                        : '',
                      timeframeOfPurchase: moment(
                        lead.timeframeOfPurchase
                      ).format('YYYY-MM-DD'),
                      pastInsurance: lead.everInsured,
                      additionalInformation: lead.additionalInformation,
                    },
                  });

                  const leadListPayload = await leadHealthList.map(mapLead);

                  // Handle Lead Type 3 special case
                  if (
                    selectedLeadTypeId &&
                    selectedLeadTypeId == 5 &&
                    hasData
                  ) {
                    const isValid = await validateHealthLead();

                    if (!isValid) {
                      return;
                    }

                    leadListPayload.push({
                      leadName:
                        leadHealthDetails.firstname +
                        ' ' +
                        leadHealthDetails.lastname,
                      leadNumber: leadHealthDetails.contactNumber,
                      state: Number(locationData.state),
                      district: Number(locationData.district),
                      city: Number(locationData.city),
                      zone: Number(locationData.zone),
                      pincode: locationData.pincode,
                      productId: null,
                      healthLobLeadReq: {
                        firstName: leadHealthDetails.firstname,
                        lastName: leadHealthDetails.lastname,
                        alternateMobileNumber:
                          leadHealthDetails.alternateContactNumber,
                        typeOfCoverId: leadHealthDetails.typeofCover,
                        coverageId: leadHealthDetails.coverage,
                        coverageForId: leadHealthDetails.coverageFor,
                        aadhaarNumber: leadHealthDetails.AadharNumber,
                        dateOfBirth: leadHealthDetails?.date
                          ? moment(leadHealthDetails.date).format('YYYY-MM-DD')
                          : '',
                        timeframeOfPurchase: moment(
                          leadHealthDetails.timeframeOfPurchase
                        ).format('YYYY-MM-DD'),
                        pastInsurance: leadHealthDetails.everInsured,
                        additionalInformation:
                          leadHealthDetails.additionalInformation,
                      },
                    });
                  }

                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                } else if (selectedLeadTypeId && selectedLeadTypeId == 6) {
                  const hasData =
                    leadMotorDetails?.firstname ||
                    leadMotorDetails?.lastname ||
                    leadMotorDetails?.contactNumber ||
                    leadMotorDetails?.alternateContactNumber ||
                    leadMotorDetails?.riskCoverage ||
                    leadMotorDetails.vehicleType ||
                    leadMotorDetails?.make ||
                    leadMotorDetails?.OwnerNameASPerRC ||
                    leadMotorDetails?.VehicleRegnNo ||
                    leadMotorDetails?.AadharNumber ||
                    leadMotorDetails?.date ||
                    leadMotorDetails?.timeframeOfPurchase ||
                    leadMotorDetails?.everInsured ||
                    leadMotorDetails?.additionalInformation ||
                    locationData?.pincode;

                  const mapLead = (lead: any) => ({
                    leadName: lead.firstname + ' ' + lead.lastname,
                    leadNumber: lead.contactNumber,
                    state: Number(lead.state),
                    district: Number(lead.district),
                    city: Number(lead.city),
                    zone: Number(lead.zone),
                    pincode: lead.pincode,
                    productId: null,
                    motorLobLeadReq: {
                      firstName: lead.firstname,
                      lastName: lead.lastname,
                      alternateMobileNumber: lead.alternateContactNumber,
                      riskCoverageId: lead.riskCoverage,
                      vehicleTypeId: lead.vehicleType,
                      vehicleMake: lead.make,
                      ownerNameAsPerRc: lead.OwnerNameASPerRC,
                      vehicleRegistrationNumber: lead.VehicleRegnNo,
                      aadhaarNumber: lead.AadharNumber,
                      dateOfBirth: lead?.date
                        ? moment(lead.date).format('YYYY-MM-DD')
                        : '',
                      timeframeOfPurchase: moment(
                        lead.timeframeOfPurchase
                      ).format('YYYY-MM-DD'),
                      pastInsurance: lead.everInsured,
                      additionalInformation: lead.additionalInformation,
                    },
                  });

                  const leadListPayload = await leadMotorList.map(mapLead);

                  // Handle Lead Type 3 special case
                  if (
                    selectedLeadTypeId &&
                    selectedLeadTypeId == 6 &&
                    hasData
                  ) {
                    const isValid = await validateMotorLead();

                    if (!isValid) {
                      return;
                    }

                    leadListPayload.push({
                      leadName:
                        leadMotorDetails.firstname +
                        ' ' +
                        leadMotorDetails.lastname,
                      leadNumber: leadMotorDetails.contactNumber,
                      state: Number(locationData.state),
                      district: Number(locationData.district),
                      city: Number(locationData.city),
                      zone: Number(locationData.zone),
                      pincode: locationData.pincode,
                      productId: null,
                      motorLobLeadReq: {
                        firstName: leadMotorDetails.firstname,
                        lastName: leadMotorDetails.lastname,
                        alternateMobileNumber:
                          leadMotorDetails.alternateContactNumber,
                        riskCoverageId: leadMotorDetails.riskCoverage,
                        vehicleTypeId: leadMotorDetails.vehicleType,
                        vehicleMake: leadMotorDetails.make,
                        ownerNameAsPerRc: leadMotorDetails.OwnerNameASPerRC,
                        vehicleRegistrationNumber:
                          leadMotorDetails.VehicleRegnNo,
                        aadhaarNumber: leadMotorDetails.AadharNumber,
                        dateOfBirth: leadMotorDetails?.date
                          ? moment(leadMotorDetails.date).format('YYYY-MM-DD')
                          : '',
                        timeframeOfPurchase: moment(
                          leadMotorDetails.timeframeOfPurchase
                        ).format('YYYY-MM-DD'),
                        pastInsurance: leadMotorDetails.everInsured,
                        additionalInformation:
                          leadMotorDetails.additionalInformation,
                      },
                    });
                  }

                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                } else if (selectedLeadTypeId && selectedLeadTypeId == 7) {
                  const hasData =
                    leadOtherDetails?.firstname ||
                    leadOtherDetails?.lastname ||
                    leadOtherDetails?.contactNumber ||
                    leadOtherDetails?.alternateContactNumber ||
                    leadOtherDetails?.interestedFor ||
                    leadOtherDetails?.AadharNumber ||
                    leadOtherDetails?.date ||
                    leadOtherDetails?.timeframeOfPurchase ||
                    leadOtherDetails?.everInsured ||
                    leadOtherDetails?.additionalInformation ||
                    locationData?.pincode;

                  const mapLead = (lead: any) => ({
                    leadName: lead.firstname + ' ' + lead.lastname,
                    leadNumber: lead.contactNumber,
                    state: Number(lead.state),
                    district: Number(lead.district),
                    city: Number(lead.city),
                    zone: Number(lead.zone),
                    pincode: lead.pincode,
                    productId: null,
                    otherLobLeadReq: {
                      firstName: lead.firstname,
                      lastName: lead.lastname,
                      alternateMobileNumber: lead.alternateContactNumber,
                      interestedForId: lead.interestedFor,
                      aadhaarNumber: lead.AadharNumber,
                      dateOfBirth: lead?.date
                        ? moment(lead.date).format('YYYY-MM-DD')
                        : '',
                      timeframeOfPurchase: moment(
                        lead.timeframeOfPurchase
                      ).format('YYYY-MM-DD'),
                      everInsured: lead.everInsured,
                      additionalInformation: lead.additionalInformation,
                    },
                  });

                  const leadListPayload = await leadOtherList.map(mapLead);

                  // Handle Lead Type 3 special case
                  if (
                    selectedLeadTypeId &&
                    selectedLeadTypeId == 7 &&
                    hasData
                  ) {
                    const isValid = await validateOtherLead();

                    if (!isValid) {
                      return;
                    }

                    leadListPayload.push({
                      leadName:
                        leadOtherDetails.firstname +
                        ' ' +
                        leadOtherDetails.lastname,
                      leadNumber: leadOtherDetails.contactNumber,
                      state: Number(locationData.state),
                      district: Number(locationData.district),
                      city: Number(locationData.city),
                      zone: Number(locationData.zone),
                      pincode: locationData.pincode,
                      productId: null,
                      otherLobLeadReq: {
                        firstName: leadOtherDetails.firstname,
                        lastName: leadOtherDetails.lastname,
                        alternateMobileNumber:
                          leadOtherDetails.alternateContactNumber,
                        interestedForId: leadOtherDetails.interestedFor,
                        aadhaarNumber: leadOtherDetails.AadharNumber,
                        dateOfBirth: leadOtherDetails?.date
                          ? moment(leadOtherDetails.date).format('YYYY-MM-DD')
                          : '',
                        timeframeOfPurchase: moment(
                          leadOtherDetails.timeframeOfPurchase
                        ).format('YYYY-MM-DD'),
                        everInsured: leadOtherDetails.everInsured,
                        additionalInformation:
                          leadOtherDetails.additionalInformation,
                      },
                    });
                  }

                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                } else {
                  const leadListPayload: any = [];
                  createLead(
                    {
                      leadDetails,
                      lobName,
                      completionDateTime,
                      selectedEmployee,
                      selectedLeadTypeId,
                      locationData,
                      comment,
                      rmName,
                      rmMobileNum,
                      selectedBank,
                      selectedBranch,
                      leadListPayload,
                    },
                    setShowLoader,
                    dispatch,
                    clearFields
                  );
                }
              } else {
                updateLeadStatus(
                  {
                    leadId: leadUniqueId,
                    comments: comment ?? '',
                    leadStatus: optionTaskStatus,
                  },
                  leadToViewDetails,
                  optionTaskStatus,
                  setShowLoader,
                  dispatch,
                  handleLeadsData,
                  setLeadToViewDetails
                );
              }
            }}
          >
            {leadStatus === TASK_ACTION.CREATE
              ? 'Create Lead'
              : 'Update Status'}
          </Button>
          <Button
            variant="primary-outline"
            className=" mt-2 mx-4"
            onClick={() => {
              if (leadStatus === TASK_ACTION.CREATE) {
                navigateToViewListPage();
              } else if (onTaskAction)
                onTaskAction(CLICK_ACTIONS.CLOSE_VIEW_LEAD);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} />
    </div>
  );
};

export default CreateLeadPage;
